/* eslint-disable no-unused-vars */
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { map, Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ICStoneToken } from "./interfaces/token.interface";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  endPoint = `${environment.apiUrlCap}/api/cornerStone/token`;
  constructor(private http: HttpClient) {}

  getToken(scope?: string): Observable<ICStoneToken> {
    const options = {
      headers: new HttpHeaders({
        accept: "*/*",
      }),
      params: new HttpParams(),
    };
    // Only Mapped "All"
    if (scope) {
      options.params = options.params.set("scope", scope);
    }
    return this.http
      .get<ResponseDataInterfaces<ICStoneToken>>(this.endPoint, options)
      .pipe(map(completeResponse => completeResponse.data));
  }
}
